<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    {
        title: `1 ${t('Day')}`,
        value: '-1 days'
    },
    {
        title: `1 ${t('Week')}`,
        value: '-1 week'
    },
    {
        title: `3 ${t('Months')}`,
        value: '-3 month'
    },
    {
        title: `6 ${t('Months')}`,
        value: '-6 month'
    }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="$t('Search Start Date')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
